<template>
</template>

<script>
export default {
    name: 'Blank',
    data() {
        return {};
    },
    methods: {}
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Administration/Blank.vue